import { ForgotPasswordReset } from 'containers/Auth'

export default ForgotPasswordReset
